
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.footer-wrapper {
    width: 100%;
    background-color: var(--primary-blue);
    color: var(--neutral-white)
}
.footer {
    padding-top: 3rem;
    padding-bottom: 3rem
}
@media (min-width: 1024px) {
    .footer {
        padding-left: 2rem;
        padding-right: 2rem
    }
}
@media (min-width: 1024px) {
    .footer .footer-top-supersection {
        display: flex
    }
}
.footer .footer-logo-section {
    padding-left: 1.5rem;
    padding-right: 1.5rem
}
.footer .footer-logo-section {
    text-align: center
}
.footer .footer-logo-section {
    font-family: var(--ff-body)
}
.footer .footer-logo-section {
    font-size: var(--fs-lg);
    line-height: var(--lh-lg)
}
@media (min-width: 1024px) {
    .footer .footer-logo-section {
        flex-grow: 0
    }
}
@media (min-width: 1024px) {
    .footer .footer-logo-section {
        padding-left: 0px;
        padding-right: 0px
    }
}
@media (min-width: 1024px) {
    .footer .footer-logo-section {
        text-align: left
    }
}
.footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
    margin-left: 1rem;
    margin-right: 1rem
}
.footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
    font-family: var(--ff-display)
}
@media (min-width: 1024px) {
    .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
        margin-left: 0px;
        margin-right: 0px
    }
}
@media (min-width: 1024px) {
    .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
        margin-left: 4rem
    }
}
@media (min-width: 1024px) {
    .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
        display: grid
    }
}
@media (min-width: 1024px) {
    .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
        flex-grow: 1
    }
}
@media (min-width: 1024px) {
    .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
        grid-template-columns: repeat(3, minmax(0, 1fr))
    }
}
@media (min-width: 1024px) {
    .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
        gap: 2.5rem
    }
}
@media (min-width: 1280px) {
    .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
        margin-left: 9rem
    }
}
@media (min-width: 1360px) {
    .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
        margin-left: 12rem
    }
}
.footer .footer-disclaimer-et-al-section {
    padding-left: 1rem;
    padding-right: 1rem
}
.footer .footer-disclaimer-et-al-section {
    text-align: center
}
@media (min-width: 1024px) {
    .footer .footer-disclaimer-et-al-section {
        display: flex
    }
}
@media (min-width: 1024px) {
    .footer .footer-disclaimer-et-al-section {
        justify-content: space-between
    }
}
@media (min-width: 1024px) {
    .footer .footer-disclaimer-et-al-section {
        padding-left: 0px;
        padding-right: 0px
    }
}
.footer .footer-links {
    margin-bottom: 1rem
}
.footer .footer-links {
    width: 100%
}
.footer .footer-links {
    font-family: var(--ff-display)
}
.footer .footer-brand-logo {
    margin-left: auto;
    margin-right: auto
}
.footer .footer-brand-logo {
    max-width: 140px
}
.footer .footer-brand-logo {
    padding-bottom: 1.75rem
}
.footer .footer-brand-logo {
    font-size: var(--fs-2xl);
    line-height: var(--lh-2xl)
}
@media (min-width: 1024px) {
    .footer .footer-brand-logo {
        margin-left: 0px;
        margin-right: 0px
    }
}
@media (min-width: 1024px) {
    .footer .footer-brand-logo {
        max-width: 200px
    }
}
.footer .footer-contact {
    padding-bottom: 0.625rem
}
.footer .footer-social-icons {
    padding-bottom: 1.5rem
}
.footer .footer-great-divide-hr {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem
}
.footer .footer-great-divide-hr {
    height: 1px
}
.footer .footer-great-divide-hr {
    border-style: none
}
.footer .footer-great-divide-hr {
    background-color: var(--primary-blue-dark)
}
.footer .footer-privacy-policy, .footer .footer-terms-of-use, .footer .footer-contact-us {
    margin-left: auto;
    margin-right: auto
}
.footer .footer-privacy-policy, .footer .footer-terms-of-use, .footer .footer-contact-us {
    margin-bottom: 1.5rem
}
.footer .footer-privacy-policy, .footer .footer-terms-of-use, .footer .footer-contact-us {
    font-family: var(--ff-display)
}
.footer .footer-privacy-policy, .footer .footer-terms-of-use, .footer .footer-contact-us {
    font-size: var(--fs-sm);
    line-height: var(--lh-sm)
}
.footer .footer-copyright {
    margin-bottom: 2rem
}
.footer .footer-copyright {
    font-family: var(--ff-body)
}
@media (min-width: 1024px) {
    .footer .footer-copyright {
        text-align: left
    }
}
.footer .footer-btt {
    width: 100%
}
.footer .footer-btt {
    font-family: var(--ff-display)
}
@media (min-width: 1024px) {
    .footer .footer-btt {
        width: 31%
    }
}
@media (min-width: 1024px) {
    .footer .footer-btt {
        text-align: right
    }
}
@media (min-width: 1280px) {
    .footer .footer-btt {
        width: 20%
    }
}
`;